(function () {
  'use strict';

  var ENHANCED_ATTR = 'data-cure-enhanced';

  // ─── Helpers ──────────────────────────────────────────────────────────────

  function toDollars(str) {
    if (!str) return null;
    var s = (str + '').trim();
    if (!s) return null;
    if (/^\d+$/.test(s)) return parseInt(s, 10) / 100;
    var n = parseFloat(s.replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : n;
  }

  function formatMoney(dollars) {
    if (dollars === null || isNaN(dollars)) return '';
    return '$' + (dollars % 1 === 0 ? String(dollars) : dollars.toFixed(2));
  }

  function extractDiscount(input) {
    var ariaLabel = input.getAttribute('aria-label') || '';
    var m = ariaLabel.match(/(\d+)%\s*off/i);
    if (m) return parseInt(m[1], 10);
    var price = toDollars(input.dataset.variantPrice);
    var compare = toDollars(input.dataset.variantCompareAtPrice);
    if (price && compare && compare > price) {
      return Math.round((1 - price / compare) * 100);
    }
    return null;
  }

  function extractFrequency(input) {
    var ariaLabel = input.getAttribute('aria-label') || '';
    var m = ariaLabel.match(/deliver\s+every\s+(.+?)(?:,|\.)/i);
    if (m) {
      var raw = m[1].trim();
      return 'Every ' + raw.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }
    return null;
  }

  // ─── Transform subscription group ─────────────────────────────────────────

  function transformSubscriptionGroup(group, input) {
    var discountPct = extractDiscount(input);
    var frequency = extractFrequency(input);
    var priceDollars = toDollars(input.dataset.variantPrice);
    var compareDollars = toDollars(input.dataset.variantCompareAtPrice);
    var priceDisplay = formatMoney(priceDollars);
    var compareDisplay = compareDollars ? formatMoney(compareDollars) : '';
    var savings = (priceDollars && compareDollars && compareDollars > priceDollars)
      ? Math.round(compareDollars - priceDollars) : null;

    var titleText = discountPct ? 'Subscribe & Save ' + discountPct + '%' : 'Subscribe & Save';

    if (input.parentNode) input.parentNode.removeChild(input);

    group.innerHTML = '';
    group.classList.add('cure-sub-group');

    // — Title row —
    var titleLabel = document.createElement('label');
    titleLabel.className = 'cure-sub-title-row';
    if (input.id) titleLabel.htmlFor = input.id;

    var labelLeft = document.createElement('div');
    labelLeft.className = 'cure-sub-label-left custom_radio_button';
    labelLeft.appendChild(input);
    var titleSpan = document.createElement('span');
    titleSpan.textContent = titleText;
    labelLeft.appendChild(titleSpan);

    var pricesDiv = document.createElement('div');
    pricesDiv.className = 'cure-sub-prices';
    if (compareDisplay) {
      var compareSpan = document.createElement('span');
      compareSpan.className = 'cure-compare-price';
      compareSpan.textContent = compareDisplay;
      pricesDiv.appendChild(compareSpan);
    }
    var priceSpan = document.createElement('span');
    priceSpan.className = 'cure-sale-price';
    priceSpan.textContent = priceDisplay;
    pricesDiv.appendChild(priceSpan);

    titleLabel.appendChild(labelLeft);
    titleLabel.appendChild(pricesDiv);
    group.appendChild(titleLabel);

    // — Frequency badge —
    if (frequency) {
      var badge = document.createElement('span');
      badge.className = 'cure-frequency-badge';
      badge.textContent = frequency;
      group.appendChild(badge);
    }

    // — Divider —
    var hr = document.createElement('hr');
    hr.className = 'cure-benefits-divider';
    group.appendChild(hr);

    // — Benefits —
    var ul = document.createElement('ul');
    ul.className = 'cure-benefits';
    var benefits = [];
    if (savings) benefits.push('<strong>SAVE $' + savings + '</strong> on every order');
    benefits.push('Auto-renews. Pause, skip, or cancel anytime');
    benefits.push('Always <strong>FREE Shipping</strong>');
    benefits.forEach(function (html) {
      var li = document.createElement('li');
      li.innerHTML = html;
      ul.appendChild(li);
    });
    group.appendChild(ul);
  }

  // ─── Transform one-time group ──────────────────────────────────────────────

  function transformOneTimeGroup(group) {
    var priceEl = group.querySelector('.in_widget_price');
    if (priceEl) {
      priceEl.classList.remove('shopify_subscriptions_app_block--hidden');
      priceEl.classList.add('cure-one-time-price');
      priceEl.removeAttribute('aria-hidden');
    }

    var negatives = document.createElement('ul');
    negatives.className = 'cure-one-time-negatives';
    ['No FREE Shipping', 'No subscriber savings'].forEach(function (text) {
      var li = document.createElement('li');
      li.textContent = text;
      negatives.appendChild(li);
    });
    group.appendChild(negatives);
  }

  // ─── Transform a full section ──────────────────────────────────────────────

  function transformSection(section) {
    if (section.hasAttribute(ENHANCED_ATTR)) return;
    section.setAttribute(ENHANCED_ATTR, '1');

    var planCard = section.querySelector('.plan_card');
    if (!planCard) return;

    var groups = Array.from(planCard.querySelectorAll('.subscription_group'));
    var subscriptionInput = null;
    var oneTimeInput = null;

    groups.forEach(function (group) {
      var sellingPlanInput = group.querySelector('input[data-radio-type="selling_plan"]');
      var oneTimePurchaseInput = group.querySelector('input[data-radio-type="one_time_purchase"]');

      if (sellingPlanInput) {
        subscriptionInput = sellingPlanInput;
        transformSubscriptionGroup(group, sellingPlanInput);
      } else if (oneTimePurchaseInput) {
        oneTimeInput = oneTimePurchaseInput;
        transformOneTimeGroup(group);
      }
    });

    // Default to subscription selected
    if (subscriptionInput && oneTimeInput) {
      oneTimeInput.checked = false;
      subscriptionInput.checked = true;
      subscriptionInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // ─── Init ─────────────────────────────────────────────────────────────────

  function init() {
    document.querySelectorAll('.shopify_subscriptions_app_block').forEach(transformSection);

    // Watch for async-rendered widget blocks (Shopify app blocks can load late)
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.shopify_subscriptions_app_block')) {
            transformSection(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('.shopify_subscriptions_app_block').forEach(transformSection);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
